import {getGameHistoryListHTML} from '@gongxigames/framework/slot/modules/gameHistory/GameHistoryHTML';
import {CoreDI, LanguageService, lazyInject} from '@gongxigames/framework/core';

export class GameHistoryView {
    @lazyInject(CoreDI.LanguageService)
    protected _languageService!: LanguageService;

    private readonly _gameHistoryContainer: HTMLElement;
    private readonly _gameHistory: HTMLElement;

    private _isOpen = false;

    constructor() {
        this._gameHistoryContainer = document.createElement('div');
        this._gameHistoryContainer.id = 'gameHistoryContainer';
        document.body.appendChild(this._gameHistoryContainer);

        this._gameHistory = document.createElement('div');
        this._gameHistory.id = 'gameHistory';
        this._gameHistoryContainer.appendChild(this._gameHistory);
    }

    public onPageClicked(url: string, openCallback: () => void, closeCallback: () => void): void {
        this._isOpen = true;

        this._gameHistory.insertAdjacentHTML('afterbegin',
            getGameHistoryListHTML(this._languageService.get('gameHistory'), url));

        document.querySelector('#gameHistory iframe')!.addEventListener( 'load', () => {
            document.querySelector('#gameHistory .close')!.addEventListener('click',
                () => closeCallback());

            openCallback();
        });
    }

    public close(): void {
        this._gameHistory.innerHTML = '';

        this._isOpen = false;
    }

    public get gameHistoryContainer(): HTMLElement {
        return this._gameHistoryContainer;
    }

    public get gameHistory(): HTMLElement {
        return this._gameHistory;
    }

    public get isOpen(): boolean {
        return this._isOpen;
    }
}
